import type { FC } from 'react';
import React from 'react';

import {
  FLIGHT_PAYMENT_LABEL_PAGE,
  PaymentPageTrackingProvider,
} from '@/clientState/providers/TrackingProviders';
import FreeCancellationDrawer from './FreeCancellationDrawer';

const FreeCancellationDrawerPay: FC = () => (
  <PaymentPageTrackingProvider>
    <FreeCancellationDrawer labelPage={FLIGHT_PAYMENT_LABEL_PAGE} />
  </PaymentPageTrackingProvider>
);

export default FreeCancellationDrawerPay;
